export const cityOverrides = ['24510', '51760', '51600', '51620', '51770'];

export const statesInformation = [
  { abbr: 'AL', fips: '01' },
  { abbr: 'AK', fips: '02' },
  { abbr: 'AZ', fips: '04' },
  { abbr: 'AR', fips: '05' },
  { abbr: 'CA', fips: '06' },
  { abbr: 'CO', fips: '08' },
  { abbr: 'CT', fips: '09' },
  { abbr: 'DE', fips: '10' },
  { abbr: 'DC', fips: '11' },
  { abbr: 'FL', fips: '12' },
  { abbr: 'GA', fips: '13' },
  { abbr: 'HI', fips: '15' },
  { abbr: 'ID', fips: '16' },
  { abbr: 'IL', fips: '17' },
  { abbr: 'IN', fips: '18' },
  { abbr: 'IA', fips: '19' },
  { abbr: 'KS', fips: '20' },
  { abbr: 'KY', fips: '21' },
  { abbr: 'LA', fips: '22' },
  { abbr: 'ME', fips: '23' },
  { abbr: 'MD', fips: '24' },
  { abbr: 'MA', fips: '25' },
  { abbr: 'MI', fips: '26' },
  { abbr: 'MN', fips: '27' },
  { abbr: 'MS', fips: '28' },
  { abbr: 'MO', fips: '29' },
  { abbr: 'MT', fips: '30' },
  { abbr: 'NE', fips: '31' },
  { abbr: 'NV', fips: '32' },
  { abbr: 'NH', fips: '33' },
  { abbr: 'NJ', fips: '34' },
  { abbr: 'NM', fips: '35' },
  { abbr: 'NY', fips: '36' },
  { abbr: 'NC', fips: '37' },
  { abbr: 'ND', fips: '38' },
  { abbr: 'OH', fips: '39' },
  { abbr: 'OK', fips: '40' },
  { abbr: 'OR', fips: '41' },
  { abbr: 'PA', fips: '42' },
  { abbr: 'PR', fips: '72' },
  { abbr: 'RI', fips: '44' },
  { abbr: 'SC', fips: '45' },
  { abbr: 'SD', fips: '46' },
  { abbr: 'TN', fips: '47' },
  { abbr: 'TX', fips: '48' },
  { abbr: 'UT', fips: '49' },
  { abbr: 'VT', fips: '50' },
  { abbr: 'VA', fips: '51' },
  { abbr: 'VI', fips: '78' },
  { abbr: 'WA', fips: '53' },
  { abbr: 'WV', fips: '54' },
  { abbr: 'WI', fips: '55' },
  { abbr: 'WY', fips: '56' }
];

export const stateNames = statesInformation.map((stateObj) => stateObj.abbr);

export const getStateAbbr = (stateFips) => {
  return statesInformation.find((stateObj) => stateObj.fips === stateFips).abbr;
};

export const getStateFips = (stateAbbr) => {
  return statesInformation.find((stateObj) => stateObj.abbr === stateAbbr).fips;
};

export const validStateFips = ['10','11','17','18','24','26','27','34','36','37','39','42','45','51','54','55'];
export const validStateAbbrs = validStateFips.map(fip => getStateAbbr(fip));